import React from 'react'
import { FieldErrors, FieldName } from 'react-hook-form/dist/types'
import styles from './formError.module.scss'

interface Props<T> {
  errors: FieldErrors<T>
  field: FieldName<T>
}

function FormError<T>({ errors, field }: Props<T>) {
  if (!errors[field]) {
    return null
  }
  return (
    <p className={styles.error}>
      {errors[field].message
        ? errors[field].message
        : errors[field].types.message}
    </p>
  )
}

export default FormError
